import React from 'react'
import {injectIntl} from 'react-intl'
import FormControl from '@mui/material/FormControl'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Button from '@mui/material/Button'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import TextField from '@mui/material/TextField'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Autocomplete from 'components/Autocomplete'

const options = ['DetailName', 'MasterName']

class RelationConfig extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            create: false,
            title: '',
            from: props.config ? props.config.ecnFrom : props.entities[0].id,
            verb: props.config ? props.config.verb : '@' + options[0]
        }
    }

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    handleClick = () => {
        this.props.config ?
        this.props.handleUpdate(this.props.config.id, this.state.verb) :
        this.props.handleCreate(this.state.create ? -1 : this.state.from,
            this.props.entityId,
            this.state.verb,
            this.state.create ? this.state.title : '')
        this.props.onClose()
    }

    render() {
        const {intl} = this.props

        return (
            <React.Fragment>
                <DialogTitle>
                    {this.props.config ? intl.formatMessage({id: "record.edit_relation"}) :
                        intl.formatMessage({id: "record.create_new_relation"})}
                </DialogTitle>
                <DialogContent sx={{overflowY: 'visible'}}>
                    {this.state.create ?
                        <TextField variant="standard"
                            onChange={this.handleChange}
                            name='title'
                            label={intl.formatMessage({id: "record.new_table_name"})}
                            sx={{width: '100%', marginBottom: '20px'}}
                            defaultValue={this.state.title}
                            InputLabelProps={{
                                shrink: true
                            }}
                        /> :
                        <FormControl sx={{width: '100%', marginBottom: '20px'}} variant="standard">
                            <InputLabel>{intl.formatMessage({id: "record.from_table"})}</InputLabel>
                            <Select
                                disabled={!!this.props.config}
                                value={this.state.from}
                                onChange={this.handleChange}
                                inputProps={{
                                    name: 'from'
                                }}
                            >
                                {this.props.entities.map((item, index) =>
                                    <MenuItem key={index} value={item.id}>
                                        {item.singular}
                                    </MenuItem>
                                )}
                            </Select>
                        </FormControl>
                    }
                    {!this.props.config &&
                        <FormControlLabel
							sx={{width: '100%', marginBottom: '20px'}}
                            control={
                                <Checkbox
                                    checked={this.state.create}
                                    onChange={(e) => this.setState({ create: e.target.checked })}
                                />
                            }
                            label={intl.formatMessage({id: "record.create_table"})}
                        />
                    }
                    <TextField variant="standard"
                        disabled
                        label={intl.formatMessage({id: "record.to_table"})}
                        sx={{width: '100%', marginBottom: '20px'}}
                        defaultValue={this.props.entities.find(item =>
                            item.id === this.props.entityId).singular}
                        InputLabelProps={{
                            shrink: true
                        }}
                    />
                    <Autocomplete
                        style={{margin: '10px 0'}}
                        value={this.state.verb}
                        label={intl.formatMessage({id: "record.relation_verb"})}
                        onChange={(value) => this.setState({verb: value})}
                        options={options}
                        component='input'
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} color="primary">
                        {intl.formatMessage({id: "app.confirm_cancel"})}
                    </Button>
                    <Button disabled={(this.state.create && !this.state.title) || !this.state.verb}
                        onClick={this.handleClick}
                        color="primary"
                        variant="contained"
                    >
                        {this.props.config ? intl.formatMessage({id: "app.confirm_update"}) :
                        intl.formatMessage({id: "app.confirm_create"})}
                    </Button>
                </DialogActions>
            </React.Fragment>
        )
    }
}

export default injectIntl(RelationConfig)
